@let isMobile = breakpoints() === "mobile";
<section>
  <div class="container">
    <div class="row">
      <div class="col-lg-7 col-xs-12">
        <app-title [titles]="[title]" class="title" />
      </div>
      <div class="col-lg-12 col-xs-12 content">
        @if (isSent()) {
          <div #confirmation @fadeInOut class="confirmation" tabindex="-1">
            <p class="paragraph">
              Merci pour votre demande. Votre agenceur reprendra contact avec vous dans les plus brefs délais.
            </p>
            <p class="paragraph">Pour plus d'inspiration, découvrez nos réalisations.</p>
            <app-button
              [icon]="{ name: 'CHEVRON_RIGHT', color: 'WHITE' }"
              [theme]="'BLUE'"
              [url]="'/realisations'"
              class="button"
              label="Nos réalisations" />
          </div>
        } @else {
          <div class="form">
            <div class="step">
              <div class="form-item">
                Heureux de vous rencontrer
                <div class="form-item-input">
                  <app-form-item
                    (value)="updateForm($event)"
                    [customStyle]="{ width: isMobile ? '18.5rem' : '36rem' }"
                    [debounceTime]="1000"
                    [specs]="specs.fullName"
                    [theme]="'DASHED'" />
                  <span class="dot">.</span>
                </div>
              </div>
              <div class="form-item">
                Vous souhaitez prendre rendez-vous pour
                <div class="form-item-input">
                  <app-form-item
                    (value)="updateForm($event)"
                    [customStyle]="{ width: isMobile ? '25.5rem' : '50rem' }"
                    [isMobile]="isMobile"
                    [specs]="specs.offer"
                    [theme]="'DASHED'" />
                  @if (!isMobile) {
                    <span class="dot">.</span>
                  }
                </div>
              </div>
            </div>
            @if (isStepVisible(["fullName", "offer"])) {
              <div @fadeInOut class="step">
                <div class="form-item">
                  Sélectionnez votre magasin
                  <div class="form-item-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{ width: isMobile ? '25.5rem' : '50rem' }"
                      [isMobile]="isMobile"
                      [specs]="storeSpecs()"
                      [theme]="'DASHED'" />
                    @if (!isMobile) {
                      <span class="dot">.</span>
                    }
                  </div>
                </div>
              </div>
            }
            @if (isStepVisible(["fullName", "offer", "store"])) {
              <div @fadeInOut class="step step-message">
                <div class="form-item-textarea">
                  Dites-nous en plus sur votre projet :
                  <div class="form-item-textarea-input">
                    <app-form-item
                      (value)="updateForm($event)"
                      [customStyle]="{
                        'max-width': isMobile ? 'auto' : '81rem',
                        'font-size': isMobile ? '1.6rem' : '3.2rem',
                        'line-height': isMobile ? '2.4rem' : '4rem',
                      }"
                      [debounceTime]="1000"
                      [specs]="specs.message"
                      [theme]="'FILL'" />
                  </div>
                </div>
              </div>
            }
            @if (isStepVisible(["fullName", "offer", "store", "message"])) {
              <div @fadeInOut class="step step-contact">
                @if (isMobile) {
                  <div class="form-item">
                    Nous pouvons vous joindre
                    <div>
                      <span>au </span>
                      <div class="form-item-input">
                        <app-form-item
                          (value)="updateForm($event)"
                          [customStyle]="{ width: '24rem' }"
                          [debounceTime]="1000"
                          [specs]="specs.phone"
                          [theme]="'DASHED'" />
                        <span class="dot">.</span>
                      </div>
                    </div>
                    <div>
                      <span>Et à l'adresse </span>
                      <div class="form-item-input">
                        <app-form-item
                          (value)="updateForm($event)"
                          [customStyle]="{ width: '19rem' }"
                          [debounceTime]="1000"
                          [specs]="specs.email"
                          [theme]="'DASHED'" />
                        <span class="dot">.</span>
                      </div>
                    </div>
                  </div>
                } @else {
                  <div class="form-item">
                    Nous pouvons vous joindre au
                    <div class="form-item-input">
                      <app-form-item
                        (value)="updateForm($event)"
                        [customStyle]="{ width: '47rem' }"
                        [debounceTime]="1000"
                        [specs]="specs.phone"
                        [theme]="'DASHED'" />
                      <span class="dot">.</span>
                    </div>
                  </div>
                  <div class="form-item">
                    <span>Et à l'adresse </span>
                    <div class="form-item-input">
                      <app-form-item
                        (value)="updateForm($event)"
                        [customStyle]="{ width: '36.5rem' }"
                        [debounceTime]="1000"
                        [specs]="specs.email"
                        [theme]="'DASHED'" />
                      <span class="dot">.</span>
                    </div>
                  </div>
                }
                <app-form-item (value)="updateForm($event)" [specs]="specs.optin" />
              </div>
            }
            @if (isStepVisible(["fullName", "offer", "store", "message", "phone", "email"])) {
              <div @fadeInOut class="step step-submit">
                <app-button
                  (buttonClicked)="onSubmit()"
                  [icon]="{ name: 'CHEVRON_RIGHT', color: 'WHITE' }"
                  [isLoading]="isSending()"
                  [label]="'Envoyer votre message'"
                  [theme]="'BLUE'" />
                <div role="alert">
                  @if (isSendFailed()) {
                    <div class="error error-dashed">
                      Votre demande n'a pas pu être envoyée. Réessayez ou contactez votre boutique.
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
</section>
